import React, { useState, useEffect } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
} from "reactstrap";
import axios from "../../../axios";
import * as url from "../../../utils/url";
import { toastContainer } from "../../../utils/toast";
import VisibilitySelect from "./VisibilitySelect";

// TBV-671: "Update Privacy" modal for the Trivvy 3-dots menu. Shared across the
// Survey / KC / Message lists so the logic lives in one place. Sets a Trivvy's
// admin-view privacy ("Only Me" / "All Admins") via PUT /update-trivia-visibility/:id.
const UpdateTrivvyPrivacyModal = ({ open, onClose, trivvy, onUpdateSuccess }) => {
  const [visibility, setVisibility] = useState("ONLY_ME");
  const [saving, setSaving] = useState(false);

  // Sync the selection whenever the modal opens for a (different) Trivvy.
  // Legacy Trivvys with no `visibility` value default to "Only Me".
  useEffect(() => {
    const current =
      trivvy && trivvy.adminVisibility ? trivvy.adminVisibility : "ONLY_ME";
    setVisibility(current);
  }, [trivvy, open]);

  const handleSave = () => {
    if (!trivvy || !trivvy._id) {
      return;
    }
    setSaving(true);
    axios
      .put(url.updateTrivvyVisibility(trivvy._id), { adminVisibility: visibility })
      .then(() => {
        setSaving(false);
        toastContainer("Privacy updated", "success");
        if (onUpdateSuccess) {
          onUpdateSuccess(trivvy._id, visibility);
        }
        onClose();
      })
      .catch(() => {
        setSaving(false);
        toastContainer("Could not update privacy. Please try again.", "error");
      });
  };

  return (
    <Modal isOpen={open} toggle={onClose} centered>
      <ModalHeader toggle={onClose}>Update Privacy</ModalHeader>
      <ModalBody>
        <p className="mb-2 text-muted">Choose who can view this Trivvy.</p>
        <VisibilitySelect value={visibility} onChange={setVisibility} />
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" outline onClick={onClose} disabled={saving}>
          Cancel
        </Button>
        <Button color="primary" onClick={handleSave} disabled={saving}>
          {saving ? "Saving..." : "Save"}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default UpdateTrivvyPrivacyModal;
